const BASE_TYPES = [
  {
    code: "essential",
    name: "DOCTHAIR Essential",
    price: 129,
    turnaround_days: 9,
    metrics: ["fibre_diameter", "cuticle_integrity", "cuticle_damage", "porosity", "surface_damage"],
    tagline: "Fibre condition, cuticle state, porosity and damage level.",
    tagline_fr: "État de la fibre, de la cuticule, porosité et niveau de dommages.",
    features: ["5 laboratory parameters", "Optical microscopy imaging", "Hair Health Score", "Personalised routine protocol", "Report kept in your portal"],
    features_fr: ["5 paramètres de laboratoire", "Imagerie en microscopie optique", "Hair Health Score", "Protocole de soin personnalisé", "Rapport conservé dans votre espace"],
  },
  {
    code: "advanced",
    name: "DOCTHAIR Advanced",
    price: 199,
    turnaround_days: 11,
    metrics: ["fibre_diameter", "cuticle_integrity", "cuticle_damage", "porosity", "surface_damage", "tensile_strength", "breakage_resistance", "elasticity", "cortex_integrity", "heat_damage", "chemical_damage"],
    tagline: "Physical resilience, fibre structure and advanced microscopy.",
    tagline_fr: "Résilience physique, structure de la fibre, microscopie avancée.",
    features: ["11 laboratory parameters", "Tensile fracture assay", "Polarised light imaging", "Thermal and chemical damage signature", "Advanced scientific report"],
    features_fr: ["11 paramètres de laboratoire", "Essai de rupture par traction", "Imagerie en lumière polarisée", "Signature des dommages thermiques et chimiques", "Rapport scientifique avancé"],
  },
  {
    code: "complete",
    name: "DOCTHAIR Complete",
    price: 289,
    turnaround_days: 13,
    metrics: ["fibre_diameter", "cuticle_integrity", "cuticle_damage", "porosity", "surface_damage", "tensile_strength", "breakage_resistance", "elasticity", "cortex_integrity", "heat_damage", "chemical_damage", "mineral_calcium", "trace_zinc", "scalp_sebum"],
    tagline: "The complete laboratory profile, with evolution tracking over time.",
    tagline_fr: "Le profil de laboratoire complet, avec le suivi de votre évolution.",
    features: ["14 laboratory parameters", "Mineral and trace element profile", "Scalp parameters", "Premium report with specialist commentary", "My Hair Evolution tracking included"],
    features_fr: ["14 paramètres de laboratoire", "Profil minéral et oligo-éléments", "Paramètres du cuir chevelu", "Rapport premium avec commentaire de spécialiste", "Suivi My Hair Evolution inclus"],
  },
];

export const catalogForLocale = (locale = "fr") => BASE_TYPES.map(({ tagline_fr, features_fr, ...type }) => ({
  ...type,
  tagline: locale.startsWith("fr") ? tagline_fr : type.tagline,
  features: locale.startsWith("fr") ? features_fr : type.features,
}));

export const validCatalog = (data) => Array.isArray(data?.analysis_types) && data.analysis_types.length > 0;
